import { WifiOff } from 'lucide-react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { ROUTES } from '@/utils/routeUtils';

const ServiceUnavailablePage = () => {
  const navigate = useNavigate();

  return (
    <div className="h-viewport bg-background flex flex-col items-center justify-center px-4">
      <img
        alt="Lucio AI Logo"
        className="icon-themed mb-6 h-16 w-auto"
        src="/assets/lucioSymbol.svg"
      />

      <div className="flex flex-col items-center text-center">
        <div className="bg-elevated-subtle mb-4 flex h-12 w-12 items-center justify-center rounded-full">
          <WifiOff className="text-neutral-mid h-6 w-6" />
        </div>

        <h1 className="text-primary mb-2 text-lg font-semibold">Service Unavailable</h1>
        <p className="text-neutral-mid mb-6 max-w-[260px] text-xs">
          We couldn&apos;t determine your service region. Please sign in again to continue.
        </p>

        <Button
          className="border-border-strong text-secondary hover:bg-back-bg2 bg-card w-full max-w-[260px] font-medium"
          onClick={() => navigate(ROUTES.LOGIN, { replace: true })}
          variant="outline"
        >
          Back to sign in
        </Button>
      </div>
    </div>
  );
};

export default ServiceUnavailablePage;
